'use strict';
var zabbixUtil = require('../pages/alarm/zabbix-util');
var nocUtil = require('../../util/noc-util');
var util = require('../../util/property-util');

module.exports = /*@ngInject*/ ["$rootScope", "TrainTypeService", "ProjectService","ProjectCookieFactory", "$injector", function MonitoringStoreService(
  $rootScope,
  TrainTypeService,
  ProjectService,
  ProjectCookieFactory,
  $injector) {
  this.projects = {};
  this.trains = {}; /* save trains as entities 
                    {
                      'projectId': { 
                        'trainid_1': train_1, 
                        'trainid_2': train_2, ...... 
                      }
                    }*/
  this.filters = {};
  this.currentProjectId = null;
  this.currentTrain = null;
  this.setFilters = setFilters;
  this.setProjects = setProjects;
  this.getProjects = getProjects;
  this.getProjectById = getProjectById;
  this.setTrains = setTrains;
  this.getTrains = getTrains;
  this.getUnfilteredTrains = getUnfilteredTrains;
  this.setTrainByTrainId = setTrainByTrainId;
  this.getTrainByTrainId = getTrainByTrainId;
  this.updateTrainAlarms = updateTrainAlarms;
  this.deleteTrainAlarms = deleteTrainAlarms;
  this.getAlarms = getAlarms;
  this.keywordMatches = keywordMatches;


  function setProjects(projects) {
    this.projects = projects && projects.reduce((acc, project) => {
      acc[project.id] = project;
      return acc;
    }, {});
  }


  function getProjects() {
    return this.projects ? Object.keys(this.projects).map(id => this.projects[id]) : [];
  }

  function getProjectById(projectId) {
    return this.projects[projectId];
  }

  function setTrains(trains) {
    var currentTrain;
    if (this.currentTrain) {
      currentTrain = this.trains && this.trains[this.currentTrain.projectId] && this.trains[this.currentTrain.projectId] [this.currentTrain.trainId];
    }
    this.currentTrain = null;
    // Get any potential data updated locally (Alarm ACK)
    var trainsUpdateLocally = this.getUnfilteredTrains().reduce(function(accumulator, train) {
      if(train.updatedLocally) {
        if (!accumulator[train.projectId]) {
          accumulator[train.projectId] = {};
        }
        accumulator[train.projectId][train.trainId] = preprocessTrainData(train);
      }
      return accumulator;
    }, {});

    this.trains = {};
    
    trains.forEach(function(train) {
      if (!this.trains[train.projectId]) {
        this.trains[train.projectId] = {}
      }
      if (currentTrain && (currentTrain.projectId === train.projectId) && (currentTrain.trainId === train.trainId)) {
        train = currentTrain;
      }
      var preprocessTrain = preprocessTrainData(train);
      if(trainsUpdateLocally[preprocessTrain.trainId]) { // train updated locally
        var localTrain = trainsUpdateLocally[train.projectId][preprocessTrain.trainId];
        if(isAlarmsACKRemotelyUpdated(localTrain, preprocessTrain)) { // already synched remotely
          this.trains[train.projectId][train.trainId] = preprocessTrain;
        } else {
          this.trains[train.projectId][train.trainId] = localTrain;
        }
      } else {
        if (this.currentTrain && this.currentTrain.projectId === train.projectId && this.currentTrain.trainId === train.trainId) {
          this.trains[train.projectId][train.trainId] = Object.assign({},
              this.trains[train.projectId][train.trainId],
              preprocessTrain,
              {
                structure: this.trains[train.projectId][train.trainId].structure
              });
        } else {
          this.trains[train.projectId][train.trainId] = Object.assign({}, this.trains[train.projectId][train.trainId], preprocessTrain);
        }
      }
    }.bind(this));
    $rootScope.$emit('trains-updated');
    $injector.get('monitoringBehaviorSubjectService').inform('trains-updated');
  }

  function getTrains(projectId) {
    this.currentProjectId = parseInt(projectId);
    this.currentTrain = null;
    const trains = this.getUnfilteredTrains(projectId).filter(filterTrains.bind(this)).sort((x,y) => x.name < y.name ? -1 : 1);
    return trains;
  }

  function getUnfilteredTrains(currentProjectId) {
    let trains; 
    if (currentProjectId > 0) {
      trains =  this.trains[currentProjectId] ? Object.keys(this.trains[currentProjectId]).map(function(trainId) {
        return {
          ...this.trains[currentProjectId][trainId],
          projectName: ''
        }
      }.bind(this)).filter(train => !!train) : [];
    } else {
      trains = Object.keys(this.trains).reduce(function(acc, projectId) {
        var currentProjectTrains = Object.keys(this.trains[projectId]).map(function(trainId) {
          return this.trains[projectId][trainId];
        }.bind(this)).filter(train => !!train);
        acc = [
          ...acc,
          ...currentProjectTrains
        ]
        return acc;
      }.bind(this), [])
    }
    return trains && trains.sort((x,y) => x.name < y.name ? -1 : 1)
  }


  function setTrainByTrainId(trainId, train) {
    if (!this.trains) {
      this.trains = {}
    }
    if (!this.trains[train.projectId]) {
      this.trains[train.projectId] = {}
    }
    var preprocessTrain = preprocessTrainData(train);
    var localTrain =  this.trains && this.trains[train.projectId] && this.trains[train.projectId][trainId];
    if (localTrain) {
      this.trains[train.projectId][trainId] = localTrain.updatedLocally ? localTrain :  preprocessTrain;
    } else {
      this.trains[train.projectId][trainId] = preprocessTrain;
    }
    $rootScope.$emit('current-train-updated',  this.trains[train.projectId][trainId]);
    $injector.get('monitoringBehaviorSubjectService').inform('current-train-updated',  this.trains[train.projectId][trainId]);
  }

  function getTrainByTrainId(projectId, trainId) {
    this.currentTrain = {
      projectId: projectId,
      trainId: trainId
    };
    var currentTrain = this.trains[projectId] && this.trains[projectId][trainId];
    return currentTrain;
  }

  function deleteTrainAlarms(trainId, alarm) {
    var selectedTrain = this.getUnfilteredTrains(alarm.projectId).find(function(train) {
      return train.trainId === parseInt(trainId);
    });

    selectedTrain.issues = selectedTrain.issues.filter((issue) => alarm ? (isCurrentAlarm(alarm, issue) ? false : true)  : false);

    selectedTrain.structure.deviceGroups.forEach(function(deviceGroup) {
      deviceGroup.devices.forEach(function(device) {
        device.issues = device.issues.filter((issue) => alarm ? (isCurrentAlarm(alarm, issue) ? false : true)  : false);
      });
    });

    selectedTrain.structure.devices.forEach(function(device) {
      device.issues = device.issues.filter((issue) => alarm ? (isCurrentAlarm(alarm, issue) ? false : true)  : false);
    });

    selectedTrain.structure.allDevices.forEach(function(device) {
      device.issues = device.issues.filter((issue) => alarm ? (isCurrentAlarm(alarm, issue) ? false : true)  : false);
    });

    selectedTrain.updatedLocally = true;

    this.trains[selectedTrain.projectId][trainId] = preprocessTrainData(selectedTrain);

    $rootScope.$emit('trains-updated');
    $injector.get('monitoringBehaviorSubjectService').inform('trains-updated');
  }

  function updateTrainAlarms(trainId, alarms) {
    for (let index = 0; index < alarms.length; index++) {
      const alarm = alarms[index];
      var selectedTrain = this.getUnfilteredTrains(alarm.projectId).find(function(train) {
        return train.trainId === parseInt(trainId);
      });
  
      selectedTrain.issues.forEach(function(issue) {
        alarm ? (isCurrentAlarm(alarm, issue) ? issue.acknowledged = true : null)  : issue.acknowledged = true;
      });
  
      selectedTrain.structure.deviceGroups.forEach(function(deviceGroup) {
        deviceGroup.devices.forEach(function(device) {
          device.issues.forEach(function(issue){
            alarm ? (isCurrentAlarm(alarm, issue) ? issue.acknowledged = true : null)  : issue.acknowledged = true;
          });
        });
      });
  
      selectedTrain.structure.devices.forEach(function(device) {
        device.issues.forEach(function(issue){
          alarm ? (isCurrentAlarm(alarm, issue) ? issue.acknowledged = true : null)  : issue.acknowledged = true;
        });
      });
  
      selectedTrain.structure.allDevices.forEach(function(device) {
        device.issues.forEach(function(issue){
          alarm ? (isCurrentAlarm(alarm, issue) ? issue.acknowledged = true : null)  : issue.acknowledged = true;
        });
      });
    }
    
    selectedTrain.updatedLocally = true;

    this.trains[selectedTrain.projectId][trainId] = preprocessTrainData(selectedTrain);

    $rootScope.$emit('trains-updated');
    $rootScope.$emit('current-train-updated',  this.trains[selectedTrain.projectId][trainId]);
    $injector.get('monitoringBehaviorSubjectService').inform('trains-updated');
    $injector.get('monitoringBehaviorSubjectService').inform('current-train-updated',  this.trains[selectedTrain.projectId][trainId]);
  }


  function isCurrentAlarm (refAlarm, testAlarm) {
    return (refAlarm.deviceName === testAlarm.deviceName) && (refAlarm.description === testAlarm.description);
  }

  function setFilters(filters) {
    this.filters = Object.assign({}, this.filters, filters);
    $rootScope.$emit('trains-updated');
    $injector.get('monitoringBehaviorSubjectService').inform('trains-updated');
  }

  function preprocessTrainData(train) {
    train.uid = `${train.projectId}-${train.trainId}`;

    train.users = train.users && train.users.map(function(user){
        const trainBoxStat = train.trainBoxesStats && train.trainBoxesStats.find(box => box.boxId === user.boxId) ;
        user.labelClass = getLabelClassForUsers(user.logins, train.currentTrip);
        return trainBoxStat ? {
          ...user,
          ...trainBoxStat
        } : user;
    });

    for (let index = 0; index < train.trainBoxesStats.length; index++) {
      let trainBoxStat = train.trainBoxesStats[index];
      if (!train.users.find(user => user.boxId === trainBoxStat.boxId)) {
        trainBoxStat = {
          ...trainBoxStat,
          logins: trainBoxStat.userSessions,
          labelClass: getLabelClassForUsers(trainBoxStat.userSessions, train.currentTrip)
        }
        train.users = [
          ...train.users,
          trainBoxStat
        ]
      }
    }



    var trainAlarmAckStyle = getTrainAlarmAckStyle(train);
    train.issues = train.issues && train.issues.map(function(issue) {
      issue.alarmAckStyle = getIssueAckStyle(issue);
      issue.description = filteredDescription(issue.description, issue.hostname, issue.deviceName);
      issue.trainAlarmAckStyle = trainAlarmAckStyle;
      issue.trainOfficialId = train.officialId;
      var relatedDevice = train.structure && train.structure.allDevices && train.structure.allDevices.find(device => device.hostname === issue.hostname);
      var filteredName = filteredDeviceName(issue.hostname);
      issue.deviceName = relatedDevice && !filteredName.includes(" ") ? ("C" + relatedDevice.coachId + " " + filteredName) : filteredName;
      return JSON.parse(JSON.stringify(issue));
    });
    train.animationName = getAnimationName(train);
    train.alarmAckStyle =  trainAlarmAckStyle;
    train.links = sortArrayOfObjects(train.links.map(function(link){
      link.nameWithoutDash = removeDashFromLinkName(link);
      link.activeBorder = activeBorder(link.active);
      link.labelClass = getLabelClassForLink(link);
      return link;
    }), 'nameWithoutDash');

    var nocAlarms = train.issues.filter(function(issue) {
      return issue.type === 'nms-alarm';
    });

    if (train.structure) {
      const coachDeviceLayouts = train.trainConsistView && train.trainConsistView.staticConsistLayout 
                                 && train.trainConsistView.staticConsistLayout.deviceLayouts
                                .filter(deviceLayout => deviceLayout.type === "coach");
      train.structure.trainAlarmAckStyle = train.alarmAckStyle;
      train.structure.deviceGroups = train.structure.deviceGroups && train.structure.deviceGroups.map(function(deviceGroup) {
        const matchedCoachDeviceGroup = coachDeviceLayouts && coachDeviceLayouts.find(layout => layout.coach.toString() === deviceGroup.name.replace('Coach', '').trim())
        deviceGroup.paintedCoachId = matchedCoachDeviceGroup && matchedCoachDeviceGroup.name;
        deviceGroup.alarmAckStyle = getDeviceGroupAlarmAckStyle(deviceGroup.severity, deviceGroup);
        deviceGroup.devices.map(function(device) {
          deviceGroup.paintedCoachId = (device.paintedCoachId && device.paintedCoachId !== 'unknown') ? device.paintedCoachId : deviceGroup.paintedCoachId;
          device.paintedCoachId = deviceGroup.paintedCoachId;
          return preprocessTrainDeviceData(device, trainAlarmAckStyle, nocAlarms, train.structure.onlineStatus, train.projectName);
        });

        return deviceGroup;
      });

      train.structure.devices = train.structure.devices && train.structure.devices.map(function (device) {
        return preprocessTrainDeviceData(device, trainAlarmAckStyle, nocAlarms, train.structure.onlineStatus, train.projectName);
      });

      train.structure.allDevices = train.structure.allDevices && train.structure.allDevices.map(function (device) {
        return preprocessTrainDeviceData(device, trainAlarmAckStyle, nocAlarms, train.structure.onlineStatus, train.projectName);
      });

      if(train.structure.coachIssues) {
        train.structure.coachIssues.labelClassForAlarm = getLabelClassForAlarm(train.structure.coachIssues.severity, train.structure.onlineStatus);
      }

      train.structure.officialId = train.officialId;
    }

    if (train.simAlarm) {
      train.simAlarm.labelClassForAlarm = getLabelClassForAlarm(train.simAlarm.level);
    }

    train.lastSeenClass = getTimestampClass(train.lastSeen);
    train.lastOnlineClass = getTimestampClass(train.lastOnline);
    train.timestampClass = getTimestampClass(train.timestamp);

    return train;
  }

  function preprocessTrainDeviceData(device, trainAlarmAckStyle, nocAlarms, onlineStatus, projectName) {
    device.issues = device.issues.map(function(issue) {
      issue.alarmAckStyle = getIssueAckStyle(issue);
      issue.trainAlarmAckStyle = trainAlarmAckStyle;
      issue.deviceName = filteredDeviceName(issue.hostname);
      issue.description = filteredDescription(issue.description, issue.hostname, issue.deviceName);
      issue.type = issue.type ? issue.type : 'zabbix-alarm';
      issue.projectName = projectName;
      return JSON.parse(JSON.stringify(issue));
    });
    var currentDeviceNmsAlarms = nocAlarms.filter(function(issue) {
      return issue.hostname.toLowerCase() === device.hostname.toLowerCase();
    }).map(issue => {
      issue.newPaintedCoachId = device.paintedCoachId;
      return JSON.parse(JSON.stringify(issue));
    });
    device.issues = device.issues.concat(currentDeviceNmsAlarms);
    device.alarmAckStyle = getDeviceAlarmAckStyle(device.severity, device.issues);
    device.labelClassForAlarm = getLabelClassForAlarm(device.severity, onlineStatus);
    device.filteredDeviceName = filteredDeviceName(device.hostname);
    device.splittedName = getSplitName(device.hostname);
    return device;
  }

  function isAlarmsACKRemotelyUpdated(localTrain, remoteTrain) {  // How to efficiently check that alarms ACK has been updated remotely?
    var allAcknowledged = true;
    remoteTrain.issues.forEach(function(issue) {
      allAcknowledged = allAcknowledged && issue.acknowledged;
    });

    /*remoteTrain.structure.deviceGroups.forEach(function(deviceGroup) {
      deviceGroup.devices.forEach(function(device) {
        device.issues.forEach(function(issue) {
          allAcknowledged = allAcknowledged && issue.acknowledged;
        });
      });
    });

    remoteTrain.structure.devices.forEach(function (device) {
      device.issues.forEach(function(issue) {
        allAcknowledged = allAcknowledged && issue.acknowledged;
      });
    });

    remoteTrain.structure.allDevices.forEach(function (device) {
      device.issues.forEach(function(issue) {
        allAcknowledged = allAcknowledged && issue.acknowledged;
      });
    });*/

    return allAcknowledged;
  }

  function filterTrains(train) {
    var currentProjectId = this.currentProjectId;
    var inCurrentProject;
    if (currentProjectId === 0) {
      var selectedProjectId = ProjectCookieFactory.getProjectId();
      var arraySelectedIds = selectedProjectId ? (selectedProjectId.toString().includes(',') ? selectedProjectId.split(',') : [selectedProjectId]) : [];
      inCurrentProject = train.projectId ? !!arraySelectedIds.find(projectId => projectId === train.projectId.toString()) : false;
    } else {
      inCurrentProject = train.projectId ? train.projectId.toString().toLowerCase() === currentProjectId.toString().toLowerCase() : false;
    }
    var isIncluded = false;
    if (this.filters.showOfflineScheduledTrains && train.alarms) {
      var unacknowInServiceAlarms = train.alarms.filter((alarm) => {
        return (alarm.alarmId === "in-service-offline" && alarm.acknowledged === false);
      });
      if(unacknowInServiceAlarms && unacknowInServiceAlarms.length > 0) {
        isIncluded = true;
      }
    }

    var isInDepot = this.filters.outsideDepot ? train.inDepot === !this.filters.outsideDepot : true;
    var validMaintainer = this.filters.maintainers && this.filters.maintainers.length > 0 ? !!this.filters.maintainers.find(function(maintainer) {
      return train.projectName ? maintainer === (train.projectName + '-' + train.maintainer) : (maintainer === train.maintainer);
    }) : true;

    var currentServiceFilter = this.filters.currentServiceIds;
    var validCurrentServiceId = (currentServiceFilter && currentServiceFilter.length > 0) ? (train.currentTrip ? !!currentServiceFilter.find(function(serviceId) {
      return train.projectName ? serviceId === (train.projectName + "-" + (train.currentTrip &&
        train.currentTrip.tripId)) : (serviceId === train.currentTrip.tripId);
    }) : false) : true;

    var nextServiceFilter = this.filters.nextServiceIds;
    var validNextServiceId = (nextServiceFilter && nextServiceFilter.length > 0) ? (train.nextTrip ? !!nextServiceFilter.find(function(serviceId) {
      return train.projectName ? serviceId === (train.projectName + "-" + (train.nextTrip && train.nextTrip.tripId)) : (serviceId === train.nextTrip.tripId) ;
    }) : false) : true;

    var validConnServer = this.filters.connectivityServers && this.filters.connectivityServers.length > 0 ? !!this.filters.connectivityServers.find(function(connServer) {
      return train.projectName ?  connServer === (train.projectName + "-" + (train.connectivityServer || 'no-server')) : connServer === train.connectivityServer ;
    }) : true;

    var validTeleServer = this.filters.telemetryServers && this.filters.telemetryServers.length > 0 ? !!this.filters.telemetryServers.find(function(teleServer) {
      return train.projectName ? teleServer === (train.projectName + "-" + (train.telemetryServer || 'no-server')) : teleServer === train.telemetryServer;
    }) : true;

    var opened = this.filters.openedForServiceTrips ? train.inService === this.filters.openedForServiceTrips : true;
    var inService = this.filters.inCommercialServiceTrips ? !!train.currentServiceId : true;

    var trainType = train.projectName
      ? train.projectName + "-" + train.type : train.type;

    var validTrainType = this.filters.trainTypes && this.filters.trainTypes.length > 0 ? !!this.filters.trainTypes.find(function(type){
      return type.toLowerCase() === trainType.toLowerCase();
    }) : true;

    var hasAlarmKeyword = this.filters.alarmKeyword ? train.issues.reduce(function(acc, issue) {
      return acc || this.filters.alarmKeyword.charAt(0) === "!" || this.keywordMatches(issue.description);
    }.bind(this), this.filters.alarmKeyword.charAt(0) === "!") : true;

    var validAlarmStatus = this.filters.alarmACKStatuses ? (this.filters.alarmACKStatuses.length === 0 ? true : !!this.filters.alarmACKStatuses.find(function(status) {
      return status === train.alarmAckStyle['background-color'];
    })) : true;

    var validTrainSeverity = this.filters.alarmLevels ? (this.filters.alarmLevels.length === 0 ? true : !!this.filters.alarmLevels.find(function(alarmLevel) {
      return !!train.issues.find(issue => issue.severity === alarmLevel);
    })) : true;


    isIncluded = isIncluded || (inCurrentProject && isInDepot && validMaintainer && validAlarmStatus && opened && inService && validTrainType && hasAlarmKeyword && validTrainSeverity
        && validCurrentServiceId && validNextServiceId && validConnServer && validTeleServer);
    return isIncluded;
  }

  function getAlarms(projectId, trainId) {
    var trains = trainId ?  [this.getTrainByTrainId(projectId, trainId)] : this.getTrains(projectId);
    var alarms = trains.reduce(function(issues, train) {
      if (train) {
        var trainAlarmAckStyle = getTrainAlarmAckStyle(train);
        train.issues = train.issues.map(function(issue) {
          var relatedDevice = train.structure && train.structure.allDevices && train.structure.allDevices.find(device => device.hostname === issue.hostname);
          return Object.assign({}, issue, {
            trainAlarmAckStyle: trainAlarmAckStyle,
            projectId: train.projectId,
            projectName: train.projectName,
            trainName: train.name,
            paintedCoachId: relatedDevice && relatedDevice.paintedCoachId
          });
        });
        return issues.concat(train.issues).sort((i1, i2) => i1.lastChange < i2.lastChange ? 1 : -1);
      } else {
        return [];
      }

    }, []);

    if (!trainId) { // if return alarms for all trains, take into account the filters
        if (this.filters.alarmKeyword) {
            alarms = alarms.filter(function (issue) {
                return this.keywordMatches(issue.description);
            }.bind(this));
        }

        alarms = (this.filters.alarmLevels && this.filters.alarmLevels.length > 0)  ? alarms.filter(alarm => {
          return !!this.filters.alarmLevels.find(level => alarm.severity === level);
        }) : alarms;
    }
    
    return alarms;
  }

  function keywordMatches(description) {
    var keyword = this.filters.alarmKeyword.toLowerCase();
    return keyword === "!" || (keyword.charAt(0) === "!" ? !description.toLowerCase().includes(keyword.substring(1)) : description.toLowerCase().includes(keyword));
  }

  function getTrainAlarmAckStyle(train) {
    switch (train && train.alarmState && train.alarmState.background) {
      case "LIME":
        train.alarmState.background = '#28A745';
        break;
      case "YELLOW":
        train.alarmState.background = '#ffc107';
        break;
      case "RED":
        train.alarmState.background = '#dc3545';
        break;
    }
    return {
      "background-color": train && train.alarmState && train.alarmState.background,
      "color": train && train.alarmState && train.alarmState.textColor
    };
  }

  function createTrainAlarmList(train) {

    var issues = [];
    if (train.structure) {
      train.structure.deviceGroups.forEach(function(deviceGroup) {
        deviceGroup.devices.forEach(function(device) {
          device.issues.forEach(function(issue) {
            issues.push(issue);
          });
        });
      });

      train.structure.devices.forEach(function (device) {
        device.issues.forEach(function(issue) {
          issues.push(issue);
        });
      });
    }

    var nocAlarms = train.issues.filter(function(issue) {
      return issue.type === 'nms-alarm';
    });

    issues = issues.concat(nocAlarms);

    issues = issues.map(issue => {
      issue.projectId = train.projectId;
      return issue;
    });

    return issues;
  }

  function getDeviceGroupAlarmAckStyle(level, deviceGroup) {
    var groupIssues = [];
    deviceGroup.devices.forEach(function(device) {
        groupIssues = groupIssues.concat(device.issues);
    });
    return {
      'background-color': zabbixUtil.getAlarmAckColor(level, groupIssues),
      'color': 'black'
    };
  }

  function getDeviceAlarmAckStyle(level, issues) {
    return {
      'background-color': zabbixUtil.getAlarmAckColor(level, issues),
      'color': 'black'
    };

  }

  function getSplitName(toBeSplit) {
    var split = toBeSplit.split('_');
    return split[split.length - 1].replace("MAR3-B", "CCU");
  }

  function getIssueAckStyle(issue) {
      var background = issue.severity ? zabbixUtil.getSeverityColor(issue.severity) : '';

      return {
        'background-color': background,
        'color': 'black'
      };
  }

  function getLabelClassForUsers (users, trip) {
    return nocUtil.verifyLabelBasedOnUsersAndSchedule(users, trip);
  }

  function filteredDeviceName (deviceName) {
    return zabbixUtil.stripProjectAndTrain(deviceName);
  }

  var oldColors = {};
  var newColors = {};
  var animatingTrainIds = [];

  function getAnimationName (train) {
    var trainId = train.trainId;
    var animation = 'blink';
    var shouldAnimate = false;

    if (isAnimating(trainId)) {
      if (Date.now() - train.timestamp < 30000) {
        return animation;
      }
      stopAnimating(trainId);
    }

    if (oldColors.hasOwnProperty(trainId)) {
      shouldAnimate = oldColors[trainId] !== newColors[trainId];
    }

    oldColors[trainId] = newColors[trainId];

    if (shouldAnimate) {
      animatingTrainIds.push(trainId);
    }

    return shouldAnimate ? animation : 'none';
  }

  function isAnimating (trainId) {
    return animatingTrainIds.indexOf(trainId) > -1;
  }

  function stopAnimating (trainId) {
    animatingTrainIds.splice(animatingTrainIds.indexOf(trainId), 1);
  }

  function filteredDescription (description, hostname, filteredname) {
    return description.replace(hostname, filteredname);
  }

  function getLabelClassForAlarm (level, online) {
    var found = 'badge-success';

    if (util.isDefined(online) && !online) {
        return 'badge-default';
    }

    switch (level) {
        case 2:
        case 3:
            found = 'badge-warning';
            break;
        case 4:
        case 5:
            found = 'badge-danger';
            break;
        default:
            found = 'badge-success';
    }
    return found;
}


  function removeDashFromLinkName (link) {
    return nocUtil.formatLinkName(link.name);
  }

  function activeBorder (active) {
    return active ? 'border-active-link' : '';
  }

  function getLabelClassForLink (link) {
    return nocUtil.determineLabelClassForLink(link);
  }

  function sortArrayOfObjects (arr, key) {
    return arr.sort(function(a, b) {
      return a[key].localeCompare(b[key]);
    });
  }
  function getTimestampClass (timestamp) {
    if (!util.isDefined(timestamp)) {
      return 'badge-danger';
    }
    var time = (new Date().getTime() - timestamp) / 1000;
    if (time > 300) {
      return 'badge-danger';
    } else {
      return 'badge-success';
    }
  }

}];